import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';

import { Config, IConfig } from '../config/config.model';
import { Quiz, QuizQuestion, QuizResponse } from '../models';
import { Auth } from '../../root-store';

@Injectable({
    providedIn: 'root'
})
export class QuizService {
    private apiUrl: string;

    constructor(
        private http: HttpClient,
        private store: Store<Auth.State>,
        @Inject(Config) config: IConfig
    ) {
        this.apiUrl = config.apiUrl;
    }

    public answerQuestion(quizId: number, responseId: number, questionId: number, answerId: number, meta?: { [key: string]: string }): Observable<boolean> {
        return this.store.select(Auth.selectSchoolId).pipe(
            take(1),
            switchMap((schoolId: number) => this.http.put<boolean>(`${this.apiUrl}/schools/${schoolId}/quizzes/${quizId}/responses/${responseId}`, { question: questionId, answer: answerId, meta }))
        );
    }

    public createResponse(quizId: number, categoryId?: number): Observable<QuizResponse> {
        return this.store.select(Auth.selectSchoolId).pipe(
            take(1),
            switchMap((schoolId: number) => this.http.post<QuizResponse>(`${this.apiUrl}/schools/${schoolId}/quizzes/${quizId}/responses`, { category: categoryId }))
        );
    }

    public getOne(quizId: number): Observable<Quiz> {
        return this.store.select(Auth.selectSchoolId).pipe(
            take(1),
            switchMap((schoolId: number) => this.http.get<Quiz>(`${this.apiUrl}/schools/${schoolId}/quizzes/${quizId}`))
        );
    }

    public getQuestions(quizId: number): Observable<QuizQuestion[]> {
        return this.store.select(Auth.selectSchoolId).pipe(
            take(1),
            switchMap((schoolId: number) => this.http.get<QuizQuestion[]>(`${this.apiUrl}/schools/${schoolId}/quizzes/${quizId}/questions`))
        );
    }
}